import React from 'react'
import ErrorBoundary from '../../../components/ErrorBoundary'
import ProductsPage from "../../../components/settings/products/ProductsPage"

const ProductsPageWithBoundary = (props) => (
    <ErrorBoundary
        componentName="ProductsPage"
        showReload
        logToBackend
        title="Erro em Produtos e Serviços"
        message="Ocorreu um erro ao carregar os produtos e serviços. Tente recarregar."
    >
        <ProductsPage {...props} />
    </ErrorBoundary>
)

export default ProductsPageWithBoundary
